// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-rating-title {
  margin: 0 0 6px 0;
  font-size: 22px;
  font-weight: bold;
  color: #222;
}

.app-rating-subtitle {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.app-rating-stars-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 20px 0 10px 0;
}

.app-rating-star {
  font-size: 36px;
  cursor: pointer;
  color: #d1d5db;
  transition: color 0.15s ease, transform 0.15s ease;
}

.app-rating-star:hover {
  transform: scale(1.15);
}

.app-rating-star.filled {
  color: #facc15;
}

.app-rating-hint {
  text-align: center;
  font-size: 13px;
  color: #5616ea;
  margin: 8px 0 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/AppRatingModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".app-rating-title {\r\n  margin: 0 0 6px 0;\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  color: #222;\r\n}\r\n\r\n.app-rating-subtitle {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.app-rating-stars-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin: 20px 0 10px 0;\r\n}\r\n\r\n.app-rating-star {\r\n  font-size: 36px;\r\n  cursor: pointer;\r\n  color: #d1d5db;\r\n  transition: color 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.app-rating-star:hover {\r\n  transform: scale(1.15);\r\n}\r\n\r\n.app-rating-star.filled {\r\n  color: #facc15;\r\n}\r\n\r\n.app-rating-hint {\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #5616ea;\r\n  margin: 8px 0 0 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
